/* eslint-disable camelcase */
import css from 'styled-jsx/css'
import { colors } from '../../styles'
import logo from '../../assets/images/STVPLAYER_NEG_FLAT.png'
import logo1_5x from '../../assets/images/STVPLAYER_NEG_FLAT_1.5x.png'
import logo2x from '../../assets/images/STVPLAYER_NEG_FLAT_2x.png'
import logo3x from '../../assets/images/STVPLAYER_NEG_FLAT_3x.png'
import logo4_5x from '../../assets/images/STVPLAYER_NEG_FLAT_4.5x.png'

export default css`
.PlayerHeader {
  background: linear-gradient(180deg, rgba(21, 21, 21, 0.7) 0%, rgba(21, 21, 21, 0) 100%);
  border: none;
  display: flex;
  justify-content: space-between;
  gap: 16px;
  position: relative;
  z-index: 3;
  align-items: center;
  transition-duration: 200ms;
  transition-property: padding;
  padding-top: 16px;
  padding-bottom: 16px;
}

.PlayerHeader.hero-invisible {
  background: ${colors.baseBg};
}

.LogoWrap {
  display: flex;
  padding: 5px 16px 5px 0;
  gap: 16px;
  align-items: center;
  width: 376px;
  margin: 0 auto 0 0;
  flex-shrink: 1;
}

.nav {
  display: flex;
  padding: 0 16px;
  flex-shrink: 0;
}

.nav.logged-out {
  left: -105px;
}

.settings-menu {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin: 0 0 0 auto;
  gap: 8px;
  flex-shrink: 0;
  min-width: 376px;
}

.swap-icons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
}
.avatar-outer {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  display: none;
  border-radius: 8px;
}
.avatar-container {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 128px;
  box-shadow: rgb(131 64 223) 0px 0px 110px 1px;
}

.avatar-outer.loading{
  display: flex;
}

.PlayerHeader .login-link {
  color: ${colors.primaryText};
  white-space: nowrap;
  align-items: center;
  border-radius: 8px;
}

.player-plus a {
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0px;
  color: ${colors.secondaryText};
}

.player-plus a strong {
  font-weight: 700;
  color: ${colors.primaryText};
}

.SearchLink {
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
}

.SearchLink .IconLink {
  padding: 0;
  width: 40px;
}

@media (min-width: 1200px) {
  .PlayerHeader {
    align-items: center;
  }

  .PlayerHeader:hover {
    background: ${colors.baseBg};
  }

  .PlayerHeader.account-menu-active {
    background: ${colors.baseBg};
  }

  .nav {
    align-self: stretch;
    padding: 0;
  }
}

@media (max-width: 1199px) {  
  .nav {
    padding: 0;
    left: -20px;
  }
  
  .LogoWrap {
    gap: 8px;
    padding: 5px 0;
    width:auto;
  }

  .settings-menu {
    min-width: 0;
    width: auto;
  }

  .settings-menu, .swap-icons {
    gap: 12px;
    justify-content: flex-end;
  }

  .settings-menu .swap-icons .SearchLink:focus,
  .settings-menu .swap-icons .login-link:focus,
  .settings-menu #player-nav-menu:focus {
    background: ${colors.ctvBg};
  }
}

@media (max-width: 1023px){
  .player-plus {
    display: block;
  }
}

@media (max-width: 767px){
  .PlayerHeader {
    gap: 0;
    padding-top: 9px;
    padding-bottom: 9px;
    background: linear-gradient(180deg, #151515 20.04%, rgba(21, 21, 21, 0.552083) 60.33%, rgba(21, 21, 21, 0) 87.68%);
  }
  
  .player-plus {
    display: none;
  }

  .LogoWrap {
    gap: 8px;
    padding: 5px 0;
  }

  .swap-icons {
    flex-direction: row-reverse;
  }

  .settings-menu, .swap-icons {
    gap: 4px;
  }

  .settings-menu .swap-icons .SearchLink,
  .settings-menu .swap-icons .login-link,
  .settings-menu #player-nav-menu {
    min-width: 32px;
    min-height: 32px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
  }

  .settings-menu #player-nav-menu {
    padding: 0;
  }
}

@media (max-width: 329px) {
  .settings-menu .swap-icons .SearchLink {
    display: none;
  }

  .settings-menu {
    gap: 0;
  }
}


//Commented for player plus promo changes
// @media (min-width: 1200px) {
//   .PlayerHeader {
//     background: linear-gradient(180deg, ${colors.baseBg} 0%, rgba(21, 21, 21, 0.00) 100%);
//     border: none;
//   }
// }
`

export const LogoStyles = css`
.StvLogo {
  display: block;
  height: 30px;
  width: 94.5px;

  overflow: hidden;
  text-indent: 200%;
  white-space: nowrap;

  background-image: url(${logo});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;
}
@media
  (-webkit-min-device-pixel-ratio: 2),
  (min-resolution: 2dppx) {
  .StvLogo {
    background-image: url(${logo2x});
  }
}
@media
  (-webkit-min-device-pixel-ratio: 3),
  (min-resolution: 3dppx) {
  .StvLogo {
    background-image: url(${logo3x});
  }
}

@media (min-width: 900px) {
  .StvLogo {

    background-image: url(${logo1_5x});
  }
}
@media
  (min-width: 900px) and (-webkit-min-device-pixel-ratio: 2),
  (min-width: 900px) and (min-resolution: 2dppx) {
  .StvLogo {
    background-image: url(${logo3x});
  }
}
@media
  (min-width: 900px) and (-webkit-min-device-pixel-ratio: 3),
  (min-width: 900px) and (min-resolution: 3dppx) {
  .StvLogo {
    background-image: url(${logo4_5x});
  }
}
`
export const SponsorLogoStyles = css`
.SponsorLogo {
  display: inline-block;
  height: 27.5px;
  width: 125px;
  overflow: hidden;
  text-indent: 200%;
  white-space: nowrap;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: contain;

}

@media (max-width: 767px) {
  .SponsorLogo {

  }
}
`

export const IconLinkStyles = css`
.IconLink {
  cursor: pointer;
  box-sizing: content-box;
  display: flex;
  align-items: center;
  height: 32px;
  padding: 0.8rem;
  color: ${colors.primaryText};
  transform: scale(-1, 1);
}

.IconLink.nav-toggle {
  padding: 4px;
  border-radius: 8px;
}


.IconLink.nav-toggle.active {
  background-color: ${colors.ctvBg};
}

.IconLink.inactive {
  color: ${colors.white}
}

.IconLink.search {
  padding: 0;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  transform: rotate(360deg);
}

@media (pointer:fine) {
  .IconLink.inactive:hover {
    color: ${colors.IconButtonPurple};
  }
}

.text {
  font-weight: 900;
  padding-left: 8px;
  text-transform: uppercase;
}

@media (min-width: 1024px) {
  .IconLink.nav-toggle {
    display: none;
  }

  .IconLink.active.search {
    width: 40px;
  }
}

@media (max-width: 899px) {
  .text {
    display: none;
  }
}

@media (max-width:1299px){
  .IconLink.nav-toggle {
    padding: 0px;
  }

  .IconLink.nav-toggle{
    display: flex !important;
  }
}

@media (max-width: 767px) {
  .IconLink.search {
    height: 32px;
    width: 32px;
  }

  .IconLink.nav-toggle.logged-out {
    display: flex;
  }
}

@media (max-width: 329px) {
  .IconLink.search {
    display: none;
  }
}
`
